/* global window, Backbone */
window.Statistics = Backbone.Model.extend({
  defaults: {},
  url: function url() {
    'use strict';

    return '/_admin/statistics';
  }
});